import * as React from "react";

export const columns = [

    {
        field: "name",
        label: "Nazwa grupy",
        sort: "desc",
        width: 100,
    },
    {
        field: "parametersCount",
        label: "Ilość udogodnień",
        sort: "desc",
        width: 100,
        type: "custom",
        custom: function (column, row, history) {
            return row.amenities?.length
        }
    },
];

export default columns;
